import { useState } from "react";
import { Page } from "../components/ui.jsx";
import { appendItem } from "../lib/storage.js";
import { rankOf } from "../data/levels.js";
import { MEET_WITH, MEET_DURATIONS, MEET_FORMATS } from "../data/leadership.js";

// Meeting requests land in the same private leadership inbox as Wall notes.
export default function Meet({ back, userName, userRank }) {
  const [who, setWho] = useState(null);
  const [duration, setDuration] = useState(null);
  const [format, setFormat] = useState(null);
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(false);

  if (userRank < rankOf("leader")) {
    return (
      <Page
        back={back}
        eyebrow="Leaders & Directors"
        title="Grab time."
        intro="This space unlocks at Team Leader. Talk to your leader about taking the next step."
      >
        <div className="card locked">
          <div className="name">
            <span>🔒 Unlocks at Team Leader</span>
          </div>
        </div>
      </Page>
    );
  }

  const send = async () => {
    await appendItem("leadership-inbox", {
      kind: "meeting",
      name: userName,
      ts: Date.now(),
      // Routing lives in these fields, not in the sentence below.
      toPid: who.pid || undefined,
      toName: who.label,
      text: `Wants time with ${who.label} · ${duration.v} (${duration.note}) · ${format}\n\n${note.trim()}`,
    });
    setSent(true);
  };

  const ready = who && duration && format && note.trim();

  return (
    <Page
      back={back}
      eyebrow="Leaders & Directors"
      title="Grab time."
      intro="Request time with a pastor or leader. Say who, how long, and what's on your heart — we'll get it on the calendar."
    >
      {sent ? (
        <div className="card">
          <div className="name">
            <span>✓ Request sent</span>
          </div>
          <div className="desc">
            It's in the leadership inbox — expect a follow-up soon. Thanks for not carrying
            it alone.
          </div>
        </div>
      ) : (
        <>
          <label className="flabel">Who do you need?</label>
          <div className="chips">
            {MEET_WITH.map((p) => (
              <button
                key={p.label}
                className={"chip" + (who?.label === p.label ? " on" : "")}
                onClick={() => setWho(p)}
              >
                {p.label}
              </button>
            ))}
          </div>

          <label className="flabel">How much time?</label>
          <div className="chips">
            {MEET_DURATIONS.map((d) => (
              <button
                key={d.v}
                className={"chip" + (duration && duration.v === d.v ? " on" : "")}
                onClick={() => setDuration(d)}
              >
                {d.v} · {d.note}
              </button>
            ))}
          </div>

          <label className="flabel">Where?</label>
          <div className="chips">
            {MEET_FORMATS.map((f) => (
              <button
                key={f}
                className={"chip" + (format === f ? " on" : "")}
                onClick={() => setFormat(f)}
              >
                {f}
              </button>
            ))}
          </div>

          <label className="flabel">What's on your heart?</label>
          <textarea
            className="finput"
            style={{ minHeight: 100 }}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Share as much as you're ready to — it stays with leadership."
          />

          <div style={{ marginTop: 24 }}>
            <button className="btn-post" disabled={!ready} onClick={send}>
              Send the request 🤝
            </button>
          </div>
        </>
      )}
    </Page>
  );
}
